
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "../Guides/guides.css"; 
import "./getStarted.css"; 
import { MainContent, InlineBox, ImageInline, ProgressBar } from "./GetStartedHelpers.jsx";
import Tooltip from "../Guides/Tooltip.jsx";
import Seo from "../Seo.jsx";
import getStartedConfig from "../../config/getStartedConfig.js";
import betfred from "./betfred.png";
import mb3 from "./mb3.png";
import mb4 from "./mb4.png";

const GetStarted3 = () => {
  const meta = getStartedConfig.getStarted3?.seo || {};
  const progress = getStartedConfig.progress || { currentStep: 2, totalSteps: 4 };

  const navigate = useNavigate();

  // This handler will be passed to the ProgressBar.
  const handleStepClick = (stepIndex) => {
    const targetRoute = `/get-started/step${stepIndex + 1}`;
    if (targetRoute) {
      navigate(targetRoute);
    }
  };

  return (
    <MainContent>
      <Seo title={meta.title} description={meta.description} url={getStartedConfig.getStarted3?.route || "/get-started/step3"}/>

      <ProgressBar currentStep={progress.currentStep} totalSteps={progress.totalSteps} onStepClick={handleStepClick} />

      <h1>Understand Matched Betting in 180 Seconds</h1>

      <section>
        <ImageInline
          imageSrc={betfred}
          alt="Diagram of Matched Betting Basics"
          annotations={
            <div>
              <h2>Step 2: Use our free bet</h2>
              <p>We now need to lock in profit from our £50 in free bets. We do this in a way that <em>guarantees profit</em>.</p>
              <h6 className="warn">Usually, an offer like this is broken into 5 x £10 free bets.</h6>
            </div>
          }
        />
      </section>

      <section>
      <h3>How to do this?</h3>
      <div className="grid-fixed g2">
        <InlineBox>
        <img src={mb3} alt="How does matched betting work?" />
        <h3>1. Place a bet using the free bet</h3>
        <p>
          For example, place a £10 <span className="back">back</span> bet that QPR <em>will</em> win the match with <span className="key">Betfred</span>.
        </p>
        <h6 className="info mb-0">Choose an outcome of odds <Tooltip content="This is because the we don't get to keep the free bet stake. If we bet £10 at odds of 1.1 we'd only get to keep £1!">higher than 5.0</Tooltip> (4/1) to maximise profit.</h6>
        </InlineBox>
        <InlineBox>
        <img src={mb4} alt="How does matched betting work?" />
        <h3>2. Cancel out that bet</h3>
          <p>
        For example, place a <span className="lay">lay</span> bet that QPR <em>will not</em> win the match with <Tooltip content="A platform where you bet against other people, rather than a bookie.">an exchange</Tooltip>.

          </p>
        <h6 className="info mb-0">We can usually lock in profit from about <Tooltip content="This is because the we don't get to keep the free bet stake, and because odds at the bookie and exchange won't perfectly match.">70-80%</Tooltip> of a free bet's value.</h6>
        </InlineBox>
      </div>
      <h6 className="warn">Now, repeat for each £10 free bet!</h6>
    
      </section>
      <Link to="/get-started/step4">
        <button className="next-button">Next</button>
      </Link>    
    </MainContent>
  );
};

export default GetStarted3;
